import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { schedulingTask } from 'src/redux/actions/constant';
import therapistService from 'src/services/apiServices/therapist-scheduling/therapistService';

const {
  GET_TASK_NOTE_SCHEDULING_REQUEST,
  GET_TASK_NOTE_SCHEDULING_SUCCESS,
  GET_TASK_NOTE_SCHEDULING_FAILURE,
  GET_TASK_NOTE_SCHEDULING_LOADING,
  GET_TASK_NOTE_SCHEDULING_RESET,
} = schedulingTask;

function* getSchedulingTaskNote(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_TASK_NOTE_SCHEDULING_LOADING });
    const response = yield call(therapistService.getTherapistTaskNote, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_TASK_NOTE_SCHEDULING_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_TASK_NOTE_SCHEDULING_FAILURE, payload: error });
  }
}

function* getSchedulingTaskNoteSaga() {
  yield takeEvery(GET_TASK_NOTE_SCHEDULING_REQUEST, getSchedulingTaskNote);
}

export default getSchedulingTaskNoteSaga;
